/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  BorderRadius,
  BorderWidth,
  DesignTokens,
  UIColors,
} from '../types/ui-config/design-tokens';
import { THEMES } from '../theme/presets/themes';
import spacingScale from '../theme/spacing-scale.json';
import { BORDER_WIDTHS, BORDER_RADII } from '../theme/presets/border';
import { hexToRGB } from './color';
import { DyteUIContext } from '../lib/context-provider/ui-context';
import DyteUIStore from '../lib/context-provider/store';

const provideGoogleFont = (googleFont: string) => {
  const currentState = DyteUIStore.getStates();
  DyteUIStore.setStates({
    ...currentState,
    designSystem: {
      ...currentState.designSystem,
      googleFont: googleFont,
    },
  });
  //   const weights = [400, 500, 700];
  //   const links = [];
  //   if (document.querySelector('link[data-dyte-font]') == null) {
  //     /**
  //      * Adds the following preconnect link tags for faster google font loading
  //      * <link rel="preconnect" href="https://fonts.googleapis.com">
  //      * <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  //      */
  //     const p1 = document.createElement('link');
  //     p1.rel = 'preconnect';
  //     p1.setAttribute('data-dyte-font', 'true');
  //     p1.href = 'https://fonts.googleapis.com';
  //     const p2 = p1.cloneNode(true) as HTMLLinkElement;
  //     p2.href = 'https://fonts.gstatic.com';
  //     p2.crossOrigin = '';
  //     links.push(p1, p2);
  //   }
  //   const link = document.createElement('link');
  //   link.rel = 'stylesheet';
  //   link.setAttribute('data-dyte-font', fontFamily);
  //   link.href = encodeURI(
  //     `https://fonts.googleapis.com/css2?family=${fontFamily}:wght@${weights.join(
  //       ';'
  //     )}&display=swap`
  //   );
  //   links.push(link);
  //   document.head.append(...links);
};

const provideFontFamily = (fontFamily: string) => {
  const currentState = DyteUIStore.getStates();
  DyteUIStore.setStates({
    ...currentState,
    designSystem: {
      ...currentState.designSystem,
      fontFamily: fontFamily,
    },
  });
};

const provideSpacing = (spacingBase: number) => {
  const currentState = DyteUIStore.getStates();
  DyteUIStore.setStates({
    ...currentState,
    designSystem: {
      ...currentState.designSystem,
      spacingBase: spacingBase,
    },
  });
  //   spacingScale.forEach((space) => {
  //     el.style.setProperty(`--dyte-space-${space}`, `${space * spacingBase}px`);
  //   });
};

const provideBorderWidth = (borderWidth: BorderWidth) => {
  const currentState = DyteUIStore.getStates();
  DyteUIStore.setStates({
    ...currentState,
    designSystem: {
      ...currentState.designSystem,
      borderWidth: borderWidth,
    },
  });
  //   if (borderWidth in BORDER_WIDTHS) {
  //     const widths = BORDER_WIDTHS[borderWidth];
  //     Object.keys(widths).forEach((type) => {
  //       el.style.setProperty(`--dyte-border-width-${type}`, `${widths[type]}px`);
  //     });
  //   }
};

const provideBorderRadius = (borderRadius: BorderRadius) => {
  const currentState = DyteUIStore.getStates();
  DyteUIStore.setStates({
    ...currentState,
    designSystem: {
      ...currentState.designSystem,
      borderRadius: borderRadius,
    },
  });
  //   if (borderRadius in BORDER_RADII) {
  //     const radii = BORDER_RADII[borderRadius];
  //     Object.keys(radii).forEach((type) => {
  //       el.style.setProperty(`--dyte-border-radius-${type}`, `${radii[type]}px`);
  //     });
  //   }
};

const provideColors = (colors: UIColors) => {
  const currentState = DyteUIStore.getStates();
  DyteUIStore.setStates({
    ...currentState,
    designSystem: {
      ...currentState.designSystem,
      colors: {
        ...currentState.designSystem.colors,
        ...colors,
      },
    },
  });
};

//   Object.keys(colors).forEach((color: keyof UIColors) => {
//     const colorValue = colors[color];
//     if (typeof colorValue === 'string') {
//       if (color === 'text' || color === 'text-on-brand') {
//         const rgb = hexToRGB(colorValue).join(' ');
//         el.style.setProperty(`--dyte-colors-${color}-1000`, `${rgb}`);
//         el.style.setProperty(`--dyte-colors-${color}-900`, `${rgb} / 0.88`);
//         el.style.setProperty(`--dyte-colors-${color}-800`, `${rgb} / 0.76`);
//         el.style.setProperty(`--dyte-colors-${color}-700`, `${rgb} / 0.64`);
//         el.style.setProperty(`--dyte-colors-${color}-600`, `${rgb} / 0.52`);
//       } else {
//         const rgb = hexToRGB(colorValue).join(' ');
//         el.style.setProperty(`--dyte-colors-${color}`, rgb);
//       }
//     } else if (typeof colorValue === 'object') {
//       Object.keys(colorValue).forEach((shade) => {
//         const shadeValue = colorValue[shade];
//         const rgb = hexToRGB(shadeValue).join(' ');
//         el.style.setProperty(`--dyte-colors-${color}-${shade}`, rgb);
//       });
//     }
//   });

// /**
//  * Provides the design system new tokens to consume values from for styling the Dyte UI Kit's UI.
//  * @param el The element/node you want to _provide_ Dyte's design system.
//  * @param tokens The design tokens you want to updated.
//  */
export const provideDyteDesignSystem = ({
  spacingBase,
  borderRadius,
  borderWidth,
  colors,
  fontFamily,
  googleFont,
  theme,
}: DesignTokens) => {
  if (typeof googleFont === 'string') {
    provideGoogleFont(googleFont);
    //.setProperty('--dyte-font-family', googleFont);
  }

  if (typeof fontFamily === 'string') {
    provideFontFamily(fontFamily);
    //el.style.setProperty('--dyte-font-family', fontFamily);
  }

  if (typeof spacingBase === 'number') {
    provideSpacing(spacingBase);
  }

  if (typeof borderWidth === 'string') {
    provideBorderWidth(borderWidth);
  }

  if (typeof borderRadius === 'string') {
    provideBorderRadius(borderRadius);
  }

  if (typeof theme === 'string') {
    const themeColors = THEMES[theme];
    if (colors != null) provideColors(themeColors);
  }

  if (typeof colors === 'object') {
    provideColors(colors);
  }
};
